import React from "react";

const MainIntro = () => (
  <div className="hidden md:flex flex-col p-8 justify-center items-center border-b border-light-grey">
    <div className="heading-4 mb-1">Customise your watch</div>
    <div className="heading-6">Choose from the range of options below</div>
  </div>
);

export default MainIntro;
